import type { FC } from "react";

import { swSettings } from "app/common/services/swSettings";
import { DevicePickerWrapper } from "app/components/campaigns/queryBar-report/reports-pages-filters/locationPicker/CampaignsLocationStyles";
import { CountryFilter } from "app/components/filters-bar/country-filter/CountryFilter";
import { commonWebSources, getCountries } from "app/components/filters-bar/utils";
import { WebSourceFilter } from "app/components/filters-bar/websource-filter/WebSourceFilter";
import type { IFilter } from "app/components/React/FiltersBar/FiltersBar";
import { FiltersBar } from "app/components/React/FiltersBar/FiltersBar";

export enum EBacklinksSubNavFilterIDs {
    DATEPICKER = "datepicker",
    COUNTRY = "country",
    DEVICE = "device",
}

export const BacklinksSubNavFilters: FC = () => {
    const getCountryFilter = () => {
        const selectedCountryID = swSettings.current?.resources?.InitialCountry as string | undefined;
        const availableCountries = getCountries(true, swSettings?.current);

        return (
            <DevicePickerWrapper data-automation="country-filter">
                <CountryFilter
                    disabled={true}
                    selectedCountry={selectedCountryID}
                    availableCountries={availableCountries}
                    appendTo="body"
                    selectedCountryIds={selectedCountryID ? { [selectedCountryID]: true } : {}}
                />
            </DevicePickerWrapper>
        );
    };

    const getDeviceFilter = () => {
        const desktopWebSrc = commonWebSources.total();
        return (
            <DevicePickerWrapper data-automation="device-filter">
                <WebSourceFilter
                    items={[desktopWebSrc]}
                    disabled={true}
                    selectedIds={{ [desktopWebSrc.id]: true }}
                    height={60}
                    appendTo="body"
                />
            </DevicePickerWrapper>
        );
    };

    const getFilters = (): IFilter[] => {
        return [
            {
                id: EBacklinksSubNavFilterIDs.COUNTRY,
                filter: getCountryFilter(),
            },
            {
                id: EBacklinksSubNavFilterIDs.DEVICE,
                filter: getDeviceFilter(),
            },
        ];
    };

    return (
        <div className="react-filters-container">
            <FiltersBar filters={getFilters()} />
        </div>
    );
};
